// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-table-container ul.bolt-list {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  cursor: default;
  margin: 0;
  user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}
.bolt-table-container ul.bolt-list .bolt-fixed-height-list-row {
  width: 100%;
}
.bolt-table-container ul.bolt-list .bolt-list-row {
  color: inherit;
  display: flex;
  align-items: baseline;
  outline: none;
  padding: 0 20px 0 0;
  text-decoration: none;
  transition: background 80ms linear;
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-table-container ul.bolt-list .bolt-list-row {
  transition: none;
}
body.ms-vss-web-vsts-theme-hc-light .bolt-table-container ul.bolt-list .bolt-list-row {
  transition: none;
}
.bolt-table-container ul.bolt-list .bolt-list-row.bolt-list-box-multi-select-row {
  gap: 10px;
  padding: 0 20px 0 16px;
}
.bolt-table-container ul.bolt-list .bolt-list-row:hover:not(.bolt-list-box-header-row, .bolt-list-box-divider-row) {
  background-color: rgba(0, 0, 0, .02);
  background-color: var(--component-grid-row-hover-color,rgba(0, 0, 0, .02));
}
.bolt-table-container ul.bolt-list .bolt-list-row:hover:not(.bolt-list-box-header-row, .bolt-list-box-divider-row) .bolt-list-cell-content-reveal {
  opacity: 100;
}
@media (forced-colors: active) {
  .bolt-table-container ul.bolt-list .bolt-list-row:hover:not(.bolt-list-box-header-row, .bolt-list-box-divider-row) {
    background: Canvas;
    forced-color-adjust: none;
  }
  .bolt-table-container ul.bolt-list .bolt-list-row:hover:not(.bolt-list-box-header-row, .bolt-list-box-divider-row) td {
    forced-color-adjust: auto;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-table-container ul.bolt-list .bolt-list-row:hover:not(.bolt-list-box-header-row, .bolt-list-box-divider-row):not(.bolt-menuitem-divider, .comment-item) {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-table-container ul.bolt-list .bolt-list-row:hover:not(.bolt-list-box-header-row, .bolt-list-box-divider-row):not(.bolt-menuitem-divider, .comment-item) {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-table-container ul.bolt-list .bolt-list-row:hover:not(.bolt-list-box-header-row, .bolt-list-box-divider-row) .secondary-text {
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-table-container ul.bolt-list .bolt-list-row:hover:not(.bolt-list-box-header-row, .bolt-list-box-divider-row) .secondary-text {
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-table-container ul.bolt-list .bolt-list-row:hover:not(.bolt-list-box-header-row, .bolt-list-box-divider-row) .list-item-label {
  color: rgba(0, 120, 212, 1);
  color: var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-table-container ul.bolt-list .bolt-list-row:hover:not(.bolt-list-box-header-row, .bolt-list-box-divider-row) .list-item-label {
  color: rgba(0, 120, 212, 1);
  color: var(--focus-border-color,rgba(0, 120, 212, 1));
}
.bolt-table-container ul.bolt-list .bolt-list-row.focused .bolt-list-cell-content-reveal {
  opacity: 100;
}
@media (forced-colors: active) {
  .bolt-table-container ul.bolt-list .bolt-list-row.focused {
    background: Canvas;
    forced-color-adjust: none;
  }
  .bolt-table-container ul.bolt-list .bolt-list-row.focused td {
    forced-color-adjust: auto;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-table-container ul.bolt-list .bolt-list-row.focused:not(.comment-item) {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-table-container ul.bolt-list .bolt-list-row.focused:not(.comment-item) .secondary-text {
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-table-container ul.bolt-list .bolt-list-row.focused:not(.comment-item) {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-table-container ul.bolt-list .bolt-list-row.focused:not(.comment-item) .secondary-text {
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
.bolt-table-container ul.bolt-list .bolt-list-row.selected {
  background-color: rgba(222, 236, 249, 1);
  background-color: var(--component-grid-selected-row-color,rgba(222, 236, 249, 1));
  outline: none;
}
@media (forced-colors: active) {
  .bolt-table-container ul.bolt-list .bolt-list-row.selected {
    background: Canvas;
    forced-color-adjust: none;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-table-container ul.bolt-list .bolt-list-row.selected {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-table-container ul.bolt-list .bolt-list-row.selected {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
@media (forced-colors: active) {
  .bolt-table-container ul.bolt-list .bolt-list-row.selected .bolt-button.bolt-focus-treatment:focus,
  .bolt-table-container ul.bolt-list .bolt-list-row.selected .bolt-checkbox.bolt-focus-treatment:focus .bolt-checkmark {
    border-color: Background;
  }
}
.bolt-table-container ul.bolt-list .bolt-list-row.selected .bolt-list-cell:first-child {
  border-width: 2px;
}
.bolt-table-container ul.bolt-list .bolt-list-row:hover.selected {
  background-color: rgba(222, 236, 249, 1);
  background-color: var(--component-grid-action-selected-cell-hover-color,rgba(222, 236, 249, 1));
}
@media (forced-colors: active) {
  .bolt-table-container ul.bolt-list .bolt-list-row:hover.selected {
    background-color: Canvas;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-table-container ul.bolt-list .bolt-list-row:hover.selected {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-table-container ul.bolt-list .bolt-list-row:hover.selected {
  background: rgba(0, 120, 212, 1);
  background: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
.bolt-table-container ul.bolt-list .bolt-list-row.single-click-activation {
  cursor: pointer;
}
.bolt-table-container ul.bolt-list .bolt-list-row-no-hover:hover {
  background-color: initial;
}
.bolt-table-container ul.bolt-list .bolt-list-row-header:hover,
.bolt-table-container ul.bolt-list .bolt-list-row-loading:hover {
  background-color: initial;
  cursor: default;
}
.bolt-table-container ul.bolt-list .bolt-list-cell {
  border-top: 1px solid transparent;
  border-bottom: 1px solid transparent;
  overflow: hidden;
  padding: 0;
  position: relative;
  text-align: left;
  text-decoration: none;
  white-space: nowrap;
}
.bolt-table-container ul.bolt-list .bolt-list-cell:first-child:not(.bolt-table-cell-select) {
  border-left: 2px solid transparent;
  width: 100%;
  max-width: unset;
  min-width: unset;
}
.bolt-table-container ul.bolt-list .bolt-list-cell:last-child {
  border-right: 1px solid transparent;
}
.bolt-table-container ul.bolt-list .selected .bolt-list-cell:first-child {
  border-left: 2px solid transparent;
}
.bolt-table-container ul.bolt-list .bolt-list-cell-content-reveal {
  opacity: 0;
}
.bolt-table-container ul.bolt-list .bolt-list-cell-text {
  overflow: hidden;
}
.bolt-table-container ul.bolt-list .bolt-focus-visible .bolt-list-row:focus .bolt-list-cell {
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--component-grid-focus-border-color,rgba(0, 120, 212, 1));
}
@media (forced-colors: active) {
  .bolt-table-container ul.bolt-list .bolt-focus-visible .bolt-list-row:focus .bolt-list-cell {
    background-color: highlight;
  }
}
@media (forced-colors: active) {
  .bolt-table-container ul.bolt-list .bolt-focus-visible .bolt-list-row:focus {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-table-container ul.bolt-list .bolt-focus-visible .bolt-list-row:focus {
    outline: 3px double highlight;
    outline-offset: 1px;
  }
}
@media (forced-colors: active) {
  .bolt-table-container ul.bolt-list .bolt-focus-visible .bolt-list-row:focus {
    forced-color-adjust: none;
  }
  .bolt-table-container ul.bolt-list .bolt-focus-visible .bolt-list-row:focus a {
    forced-color-adjust: auto;
  }
  .bolt-table-container ul.bolt-list .bolt-focus-visible .bolt-list-row:focus > td > * {
    forced-color-adjust: auto;
  }
}
.bolt-table-container ul.bolt-list .bolt-list-row-marked .bolt-list-cell:first-child {
  border-left:  2px solid;
  border-left-color: rgba( 43, 136, 216 ,  1 );
  border-left-color: rgba( var(--palette-primary-tint-10,43, 136, 216) ,  1 );
}
.bolt-table-container ul.bolt-list .bolt-list-overlay-container {
  width: 100%;
}
.bolt-table-container ul.bolt-list .bolt-list-overlay {
  pointer-events: none;
  width: 100%;
}
.bolt-table-container ul.bolt-list .bolt-list-drag-source-item {
  background-color: rgba(255, 255, 255, 0.40);
  background-color: var(--component-grid-drag-source-color,rgba(255, 255, 255, 0.40));
}
.bolt-table-container ul.bolt-list .bolt-drag-image-portal {
  z-index: 100;
}
.bolt-table-container ul.bolt-list .bolt-drag-image {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--callout-background-color,rgba(255, 255, 255, 1));
  height: 40px;
  width: 320px;
  padding: 0px 8px;
}
.bolt-table-container ul.bolt-list .bolt-table-cell-content:not(.favorites-item-list) {
  padding: 0.375rem 0;
  overflow: hidden;
}
.bolt-table-container ul.bolt-list .bolt-table-cell-select {
  align-self: center;
}
.bolt-table-container li.bolt-list-box-loading-row {
  justify-content: center;
}
.bolt-table-container .bolt-list-box-loading-row span {
  max-width: fit-content !important;
}
.bolt-table-container .dropdown-list.artifact-list-item {
  flex-grow: 1;
}
.bolt-table-container .directory-dropdown-content .bolt-list-cell {
  flex-grow: 1;
}
.bolt-table-container span.dropdown-list.bolt-table-cell.bolt-list-cell {
  flex-grow: 1;
}

/*# sourceMappingURL=DropdownList.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/List/DropdownList.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/List/DropdownList.css","webpack://./../azure-devops-ui/src/_coreStyles.scss","webpack://./../azure-devops-ui/src/_widgetsCommon.scss"],"names":[],"mappings":"AAEA;EACI,wBC0JW;EDzJX,kDAAA;EACA,eAAA;EACA,SAAA;EACA,iBAAA;EACA,qBAAA;EACA,sBAAA;EEDF,yBAAyB;AFGvB;AEDJ;EACE,WAAW;AFIT;AEFJ;EFIQ,cAAA;EACA,aAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EEFN,kCAAkC;ADkX5B;AChXR;EACE,gBAAgB;ADkXV;AChXR;EACE,gBAAgB;AFEV;AEAR;EFEY,SAAA;EEAV,sBAAsB;AFGhB;AEDR;EACE,oCAAoC;EFG1B,0EAAA;AEDZ;AACA;ECWI,YAAA;ADTJ;AACA;EACE;IACE,kBAAkB;IFGN,yBAAA;EEDd;EACA;IACE,yBAAyB;EDyVrB;ACvVR;AACA;EACE,gCAAgC;EDwV1B,0DAAA;EDtVY,6BGhDC;EHiDD,qDCqGF;ACpGlB;ADiVQ;ED5UY,gCC+FF;ECjGhB,0DAA0D;EDiVpD,6BAAA;ED/UY,qDC+FF;AC9FlB;AD2UQ;EDtUY,6BG7DC;ED2DnB,qDAAqD;AD2U/C;ACzUR;EACE,6BAA6B;EFKnB,qDAAA;AEHZ;AACA;ECrBI,2BAAA;EHsBI,qDAAA;AEER;AACA;EACE,2BAA2B;EFKb,qDAAA;AEHhB;AACA;EACE,YAAY;ADyTN;ACvTR;EFOoB;IELhB,kBAAkB;IFOF,yBAAA;EACI;EELtB;IDqTM,yBAAA;EDpTY;AEEpB;AACA;EFAoB,gCAAA;EACI,0DCgEN;EC9DhB,6BAA6B;EFIvB,qDAAA;AEFR;AACA;EACE,6BAA6B;EChD3B,qDAAA;ADkDJ;AACA;EACE,gCFEc;EEDd,0DAA0D;EAC1D,6BAA6B;EDiSvB,qDAAA;AC/RR;AACA;EACE,6BAA6B;EDgSvB,qDAAA;AC9RR;AACA;EACE,wCAAwC;EC9DtC,iFAAA;EH8DQ,aAAA;AAAA;AEIZ;EACE;IACE,kBAAkB;IFCV,yBAAA;EACI;AEChB;AFGQ;EACI,gCInH0B;EFkHpC,0DAA0D;EC1ExD,6BAAA;EH0EI,qDAAA;AEGR;AACA;EACE,gCAAgC;EDwQ1B,0DAAA;EDrQQ,6BG9HK;EH+HL,qDCuBE;ACvBlB;ADuQQ;EDxQQ;;IEKZ,wBAAwB;EFApB;AEER;AACA;EFEI,iBAAA;AEAJ;AACA;EFGI,wCAAA;EAAA,+FAAA;AEAJ;AACA;EACE;IFIF,wBAAA;EACI;AEFJ;AACA;EFII,gCAAA;EACA,0DAAA;EACA,6BAAA;EACA,qDAAA;AEFJ;AACA;EFII,gCAAA;EACI,0DAAA;EACA,6BAAA;EACA,qDAAA;AEFR;AACA;EFKI,eAAA;AEHJ;AACA;EFQI,yBAAA;AENJ;AACA;;EFWQ,yBAAA;EERN,eAAe;AFWb;AETJ;EACE,iCAAiC;EFY/B,oCAAA;EACI,gBIvL6B;EF6KnC,UAAU;ECjIR,kBAAA;EH8IA,gBAAA;EEVF,qBFYU;EEXV,mBAAmB;AACrB;ACtII;EHoJA,kCAAA;EEXF,WCpGM;EDqGN,gBCpGM;EDqGN,gBAAgB;AAClB;ACnGI;EH2GA,mCAAA;AELJ;AACA;EACE,kCAAkC;AACpC;AClJI;EHoJA,UAAA;AECJ;AACA;EFGY,gBAAA;AEDZ;AACA;EFIY,kCAAA;EEFV,2EFGc;AEFhB;AACA;EFQI;IACI,2BAAA;EENN;AFSE;AEPJ;EACE;IFUE,yBAAA;IACI,uBAAA;EACA;AERR;AFWI;EACI;IETJ,6BAA6B;IFY7B,mBAAA;EACI;AEVR;AFaI;EACI;IACA,yBAAA;EACA;EACA;IEXJ,yBAAyB;EFczB;EACI;IACA,yBAAA;EEZN;AFeE;AEbJ;EACE,uBAAuB;EFiBzB,4CAAA;EACI,2EAAA;AEfJ;AFmBI;EACI,WAAA;AEjBR;AFqBA;EACI,oBAAA;EEnBF,WAAW;AFuBT;AErBJ;EACE,2CAA2C;EFyB7C,mFAAA;AEvBA;AACA;EACE,YAAY;AACd;AACA;EACE,wCAAwC;EACxC,wEAAwE;EACxE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA,2CAA2C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
